import { find, get } from "lodash"
import PropTypes from "prop-types"
import { formatLongDate, formatIntradayLatestPriceTimestamp } from "helpers/formatters/dates"
import { DATE } from "helpers/shapes"
import TooltipItem from "./item"

function BreakdownTooltip({ datum, items, formatter, formatters, totalKey = "total", isOneDayMode }) {
  if (datum) {
    const tooltipData = {
      [totalKey]: find(items, (item) => item.id === totalKey),
      breakdown: items.filter(item => item.id !== totalKey),
    }
    const headerText = isOneDayMode ? formatIntradayLatestPriceTimestamp(datum.date) : formatLongDate(datum.date)

    return <div className="components_breakdown-tooltip">
      <div className="header">{headerText}</div>
      <TooltipItem value={datum[totalKey]} {...tooltipData[totalKey]} formatter={formatter} />
      <div className="header decomposition">Decomposition:</div>
      {tooltipData.breakdown.map(item => <TooltipItem
        key={item.id}
        value={datum[item.id]}
        {...item}
        formatter={get(formatters, item.id, formatter)}
      />,
      )}
    </div>
  } else {
    return null
  }
}

BreakdownTooltip.propTypes = {
  formatter: PropTypes.func,
  formatters: PropTypes.object,
  datum: PropTypes.shape({
    date: DATE.isRequired,
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
  })).isRequired,
  totalKey: PropTypes.string,
  isOneDayMode: PropTypes.bool,
}

export default BreakdownTooltip
